﻿<div class="tab-buttons">
    <button
        *ngFor="let tab of tabs"
        (click)="setActivePage(tab)"
        [class.active]="tab === activeTab">
        {{ tab }}
    </button>
</div>

<div #reportContainer style="height: 800px; width: 100%; border: 1px solid #ccc;">

</div>